/**
 * Níveis padrão do sistema de avaliação (importados do tenant base a2-aquatica-001).
 * Cada nível representa uma classificação de desempenho do aluno.
 * 
 * - order: posição na escala (0 = pior, 4 = melhor)
 * - value: valor numérico usado nos cálculos de média
 */
export const DEFAULT_LEVELS = [
    {
        name: "Não avaliado",
        order: 0,
        value: 0,
        status: "active"
    },
    {
        name: "Iniciante",
        order: 1,
        value: 1,
        status: "active"
    },
    {
        name: "Regular",
        order: 2,
        value: 2,
        status: "active"
    },
    {
        name: "Bom",
        order: 3,
        value: 3,
        status: "active"
    },
    {
        name: "Muito bom",
        order: 4,
        value: 4,
        status: "active"
    }
];
